var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26ZM48.849 26C48.849 38.5645 38.6194 48.75 26.0005 48.75C13.3817 48.75 3.15206 38.5645 3.15206 26C3.15206 13.4355 13.3817 3.25 26.0005 3.25C38.6194 3.25 48.849 13.4355 48.849 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4576 17.3036L34.4326 22.845C36.8119 24.3139 36.8071 27.6913 34.4247 29.1541L25.3914 34.7024C22.8267 36.2779 19.4843 34.4761 19.5001 31.5259L19.5584 20.4356C19.5734 17.4992 22.908 15.7281 25.4576 17.3021V17.3036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleLine);
export default __webpack_public_path__ + "static/media/play-circle-line.8c7e0f57ab97f9e0fb50ea9bda266baf.svg";
export { ForwardRef as ReactComponent };